import axios from "axios"
import { frontendTabData } from "./frontendTabData.js"

/**
 * Fetches a fresh CSRF token from the server by making a GET request to the root path.
 * This creates a new session and extracts the CSRF token from the HTML response.
 * 
 * @returns {Promise<string>} The fresh CSRF token
 */
export async function refreshCsrfToken() {
  try {
    // Create a temporary axios instance without interceptors to avoid including stale CSRF token
    const refreshAxios = axios.create()
    
    // Make a GET request to the root path to get HTML with a fresh CSRF token
    // This endpoint doesn't require authentication and will create a new session
    const response = await refreshAxios.get('/', {
      responseType: 'text',
      headers: {
        'Accept': 'text/html',
        'Factz-Tab-Id': frontendTabData.tabId
      }
    })
    
    // Parse the HTML response to extract the CSRF token from the meta tag
    const parser = new DOMParser()
    const doc = parser.parseFromString(response.data, 'text/html')
    const metaTag = doc.querySelector('meta[name="csrf-token"]')
    
    if (metaTag) {
      const newToken = metaTag.getAttribute('content') || ''
      
      // Update the meta tag in the current document
      const currentMetaTag = document.querySelector('meta[name="csrf-token"]')
      if (currentMetaTag && newToken) {
        currentMetaTag.setAttribute('content', newToken)
      }
      
      return newToken
    }
    
    return ''
  } catch (error) {
    console.error('Error refreshing CSRF token:', error)
    // Return empty string on error - the request interceptor will handle it
    return ''
  }
}

/**
 * Gets the current CSRF token from the meta tag.
 * Returns empty string if meta tag doesn't exist.
 * 
 * @returns {string} The current CSRF token or empty string
 */
export function getCsrfToken() {
  const metaTag = document.querySelector('meta[name="csrf-token"]')
  return metaTag?.getAttribute('content') || ''
}
